/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { React, useState, useEffect, useContext } from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber';
import GlobalContext from "../../../../components/Context/GloablContext"
import { convertEpochToDateFormat } from '../../../../CommonMethods/convertEpochToDateFormat'


const TableBodyProviderAlert = ({ tableData, patientId,
    List,
    indexNum }) => {
    const [searchParams, setSearchParams] = useSearchParams({})
    const [loading, setLoading] = useState(false)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const date=convertEpochToDateFormat(tableData?.created_at,dateformat)
    const recipientNames = tableData?.recipients?.map(recipient => recipient.recepient_name).join(', ');

    return (
        <>
            <AnimatedList
                id={tableData.patient_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                removeHover={true}

                child={
                    <>  <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{date}</td>
                        <td className="px-[18px] py-2 text-sm text-start break-all font-normal text-[#031624]">{tableData?.alert_message}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.status}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]"> {tableData?.acknowledged_by === "" || tableData?.acknowledged_by === undefined ? "-" :tableData?.acknowledged_by}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {recipientNames || '-'}
                        </td>
                    </>

                } />
        </>
    )
}

export default TableBodyProviderAlert
